import CallIcon from '@mui/icons-material/Call';
import ChatIcon from '@mui/icons-material/Chat';
import LanguageIcon from '@mui/icons-material/Language';
import MailIcon from '@mui/icons-material/Mail';
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { INBOX_FILTER_OPTIONS_INITIAL_STATE } from '../../../../sic-lib/defaults';
import { ChannelType } from '../../../../sic-lib/enums/ChannelType';
import { GenericReducer, genericReducer } from '../../../../sic-lib/reducers/genericReducer';
import { ChannelsStats } from '../../../../sic-lib/types/ChannelsStats';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setFilters } from '../../../../store/inbox';

const useStyles = makeStyles()((theme: Theme) => ({
    /* Important for height to be inforced because is a virtual list */
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        listStyle: 'none',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
            cursor: 'pointer',
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
    checkbox: {
        paddingRight: theme.spacing(2),
    },
    action: {},
    iconContainer: {
        '& .MuiBadge-root > .MuiSvgIcon-root': {
            fontSize: '1.75rem',
            fill: theme.palette.pageNavigationBar.main,
        },
    },
}));

interface ComponentState {
    channelIcon: React.ReactElement | null;
    typeText: string;
}

interface Props {
    config: ChannelsStats;
}

export default function ChannelDetails({ config }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const filterState = useAppSelector(
        state => state.inbox?.filters.filter || INBOX_FILTER_OPTIONS_INITIAL_STATE,
    );
    const channels = useAppSelector(state => state.inbox?.filters.filter.channels || []);

    // const store = useAppSelector(state => {
    //     return {
    //         filterState: state.inbox?.filters.filter || INBOX_FILTER_OPTIONS_INITIAL_STATE,
    //         channels: state.inbox?.filters.filter.channels || [],
    //     };
    // });

    const [compState, compDispatch] = React.useReducer<GenericReducer<ComponentState>>(
        genericReducer,
        {
            channelIcon: null,
            typeText: '',
        },
    );

    React.useEffect(() => {
        let channelIcon;
        let typeText;

        switch (config.type) {
            case ChannelType.ePlans:
                channelIcon = <MailIcon />;
                typeText = 'ePlans Events';
                break;
            case ChannelType.callEvents:
                channelIcon = <CallIcon />;
                typeText = 'Call Events';
                break;
            case ChannelType.gmailEvents:
                channelIcon = <MailIcon />;
                typeText = 'Email Events';
                break;
            case ChannelType.webEvents:
                channelIcon = <LanguageIcon />;
                typeText = 'Web Events';
                break;
            case ChannelType.messageEvents:
                channelIcon = <ChatIcon />;
                typeText = 'Message Events';
                break;
            case ChannelType.actionPlans:
                channelIcon = <LanguageIcon />;
                typeText = 'Action Plans Events';
                break;
            default:
                channelIcon = <LanguageIcon />;
                typeText = 'Events';
        }

        compDispatch({
            channelIcon: channelIcon,
            typeText: typeText,
        });
    }, [config]);

    const handleFilterChange = () => {
        if (channels.indexOf(config.type) === -1) {
            //adding a new channel
            dispatch(
                setFilters({
                    filter: {
                        filter: {
                            ...filterState,
                            channels: [...channels, config.type],
                        },
                    },
                }),
            );
        }
    };

    return (
        <ListItem ContainerComponent="div" className={classes.root} onClick={handleFilterChange}>
            <ListItemIcon className={classes.checkbox}>
                <Avatar variant="rounded">{compState.channelIcon}</Avatar>
            </ListItemIcon>
            <ListItemText
                primary={`${compState.typeText}`}
                primaryTypographyProps={{
                    noWrap: true,
                    className: classes.primaryText,
                }}
                secondary={`You have ${config.count} ${compState.typeText}`}
                secondaryTypographyProps={{
                    noWrap: true,
                }}
            />
        </ListItem>
    );
}
